<template>
  <VModal
    ref="modal"
    modal-classes="max-w-md mx-auto"
    disable-backdrop-click
    @modal:hidden="$emit('closed')"
  >
    <div class="rounded shadow-xs w-full max-w-lg mx-auto" @click.stop>
      <div class="rounded shadow-lg bg-white overflow-hidden divide-y divide-gray-200">
        <div class="h-10 bg-white pl-4">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <h1 class="text-sm">Create Link</h1>
            </div>
            <div class="flex-none">
              <button
                class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
                @click="$refs.modal.close()"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                  <path
                    d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                    4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                    4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                    5.636z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="p-10">
          <LinkForm :action="tryCreateLink" @success="$refs.modal.close()" />
        </div>
      </div>
    </div>
  </VModal>
</template>

<script>
import { orderItemLinksClient } from '@/api/clients';
import LinkForm from '@/forms/LinkForm.vue';

export default {
  name: 'OrderItemAtachmentLinkCreateModal',
  components: {
    LinkForm,
  },
  props: {
    orderItemId: {
      type: String,
      required: true,
    },
  },
  methods: {
    async tryCreateLink(formData) {
      try {
        const {
          data: { data },
        } = await orderItemLinksClient.store(this.orderItemId, formData);

        const orderItemId = await this.$store.dispatch('entities/persistEntities', {
          type: 'orderItems',
          data,
        });

        this.$emit('created', orderItemId);

        return Promise.resolve(orderItemId);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
